import { select } from './select.js';
import { bugPin } from './bug-pin.js';
import { rectangle } from './rectangle.js';
import { ellipse } from './ellipse.js';
import { line } from './line.js';
import { arrow } from './arrow.js';
import { text } from './text.js';
import { number } from './number.js';
import { pencil } from './pencil.js';
import { highlight } from './highlight.js';
import { blur } from './blur.js';

export const tools = {
  select,
  'bug-pin': bugPin,
  rectangle,
  ellipse,
  line,
  arrow,
  text,
  number,
  pencil,
  highlight,
  blur,
};

export {
  select, bugPin, rectangle, ellipse, line, arrow, text, number, pencil, highlight, blur,
};
